export const PerformancePlanEmployeeColumns = [
    {
        headerName: 'employee',
        field: 'employee.fullName',
        filter: true,
        width: 280,
        checkboxSelection: true,
        headerCheckboxSelection: true
    },
    {
        headerName: 'performance.plan',
        field: 'plan.name',
        filter: true,
        width: 250
    },
    {
        headerName: 'start_date',
        field: 'startDate',
        type: 'date',
        width: 160
    },
    {
        headerName: 'end_date',
        field: 'endDate',
        type: 'date',
        width: 160
    },
    {
        headerName: 'status',
        field: 'status',
        type: 'trans',
        width: 130
    }
];
